(function() {
    const landingPlayer = () => {
        const players = document.querySelectorAll('.player');
        const trackInfo = document.querySelector('.track-info');
        let current = undefined;

        players.forEach(player => {
            const audio = player.querySelector('audio');
            const button = player.querySelector('button');
            const info = player.querySelector('.info');

            button.addEventListener('click', e => {
                e.preventDefault();

                if (current && current.audio !== audio) {
                    if (!current.audio.paused) {
                        current.audio.pause();
                        current.button.classList.toggle('pause');
                        trackInfo.classList.toggle('visible');
                    }
                    current.audio.currentTime = 0.0;
                    current = undefined;
                    trackInfo.innerHTML = '';
                }

                current = {
                    audio,
                    button,
                    info,
                };

                current.button.classList.toggle('pause');
                trackInfo.innerHTML = `<strong>Current listening:</strong> ${current.info.innerHTML}`;
                trackInfo.classList.toggle('visible');
    
                if (current.audio.paused) {
                    current.audio.play();
                } else {
                    current.audio.pause();
                }
            });
        });
    };

    var buttons = document.querySelectorAll('.cta');

    for (var button of buttons) {
        button.addEventListener('click', e => {
            e.preventDefault();
            gtag_report_conversion(e.target.href);
        });
    }

    landingPlayer();
 })();